<template>
    <div class="face_expression_recognition">
      <div class="left">
        <div class="Imagerecognition">
          <label>更换图片</label>
          <div class="imgbg">
            <div class="see imgsee" id="imgsee" v-show="imgEl!=null">
              <img id="myImg" src="http://210.5.159.76:8095//File/TemporaryFile/Uploads/images/publicize/1.png" />
              <canvas id="myCanvas"></canvas>
            </div>
            <div class="default" v-show="imgEl==null"><img src="../../../public/img/img03.png"></div>
          </div>
          <input class="updataimg" type="file" accept="image/png, image/jpeg"  @change="fnChange($event)" />
        </div>

        <div class="result">
          <div class="emote" v-for="item in expression">
            <span>{{ item.Name }}</span>
            <span>{{Math.floor(item.value*100)}}%</span>
          </div>
          <div class="gender item">
            <span>{{sex}}</span>
            <label>性别</label>
          </div>
          <div class="age item">
            <span>{{years}}</span>
            <label>年龄</label>
          </div>
        </div>

      </div>

      <div class="right">
        <div class="videorecognition">
            <!-- 视频 -->
          <label>上传视频</label>
          <div class="videosee">
            <video id="myVideo" src="" playsinline></video>
            <canvas id="myvideoCanvas"></canvas>
          </div>
          <div class="playicon" v-show="myvideoCanvas==null"><img src="../../../public/img/play.png" ></div>
          <input
            type="file"
            accept="video/mp4, video/ogg, video/webm"
            @change="videoChange($event)"
          />

          <!-- 显示内容 -->
          <div class="Identifycontent" v-show="myvideoCanvas!=null">
            <p class="title">识别信息</p>
            <div class="other">
              <p v-for="item in videoexpression">表情：{{ item.Name }}  {{ item.value*100 }}</p>
              <p>性别：{{ videosex }}</p>
              <p>年龄：{{ videoyears }}</p>
            </div>
          </div>
        </div>


        <div class="camerarecognition" @click="Openlive">
          <!-- 直播或者摄像头追踪微表情识别 -->
          <label>打开摄像头</label>
          <div class="livesee">
            <video id="mylive" src="" muted loop playsinline @loadedmetadata="liveRun"></video>
            <canvas id="myliveCanvas"></canvas>
          </div>
          <div class="playicon" v-show="myliveCanvas==null"><img src="../../../public/img/img02.png" ></div>
          <!-- <button type="button" class="play"  @click="Openlive">打开摄像头</button> -->
          <!-- 显示内容 -->
          <div class="Identifycontent" v-show="myliveCanvas!=null">
            <p class="title">识别信息</p>
            <div class="other">
              <p v-for="item in cameraexpression">表情：{{ item.Name }}  {{ Math.floor(item.value*100) }}</p>
              <p>性别：{{ camerasex }}</p>
              <p>年龄：{{ camerayears }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import * as faceapi from "face-api.js";
const MODELS_URL='/models';

export default {
  name: "tinyFaceDetector",
  data() {
    return {
      options: null, // 模型参数
      imgEl:null,
      canvasEl: null,
      expression:[{Name:'未知',value:0}],
      years:'未知',
      sex:'未知',
      expressionName:{
        angry:'生气',
        disgusted:'厌恶',
        fearful:'担心',
        happy:'开心',
        neutral:'正常',
        sad:'伤心',
        surprised:'惊喜'
      },

      // 视频
      timeout: 0,
      videoEl:null,
      myvideoCanvas:null,
      videoexpression:[],
      videoyears:'',
      videosex:'',

      // 直播
      mylive:null,
      myliveCanvas:null,
      livetimeout:0,
      cameraexpression:[],
      camerayears:'',
      camerasex:'',
      // 视频媒体参数配置
      constraints: {
        audio: false,
        video: {
          // ideal（应用最理想的）
          width: {
            min: 320,
            ideal: 1280,
            max: 1920,
          },
          height: {
            min: 240,
            ideal: 720,
            max: 1080,
          },
          // frameRate受限带宽传输时，低帧率可能更适宜
          frameRate: {
            min: 15,
            ideal: 30,
            max: 60,
          },
          // 显示模式前置后置
          facingMode: "environment",
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.fnInit().then();
    });
  },
  methods: {
    // 初始化模型加载
    async fnInit() {
      await faceapi.nets['tinyFaceDetector'].loadFromUri(MODELS_URL);//算法模型
      await faceapi.loadFaceLandmarkModel(MODELS_URL); // 轮廓模型
      await faceapi.loadFaceExpressionModel(MODELS_URL); // 表情模型
      await faceapi.loadAgeGenderModel(MODELS_URL); // 年龄模型
      
      // 节点属性化.
      // this.imgEl = document.getElementById("myImg");
      // this.canvasEl = document.getElementById("myCanvas");
    },


    // 执行识别绘制
    async fnRun() {
        // 根据模型参数识别调整结果
        this.options = new faceapi.TinyFaceDetectorOptions({
          inputSize: 224, // 160 224 320 416 512 608
          scoreThreshold: 0.1, // 0.1 ~ 0.9
        });
      const results = await faceapi
        .detectAllFaces(this.imgEl, this.options)
        .withFaceLandmarks()
        .withFaceExpressions()
        .withAgeAndGender();
      faceapi.matchDimensions(this.canvasEl, this.imgEl);
      const resizedResults = faceapi.resizeResults(results, this.imgEl);
      let statunum=0;
      resizedResults.forEach((result) => {
        for(let item in result.expressions){
          if(this.expressionName[item]){
            if(result.expressions[item]>statunum){
              statunum=result.expressions[item];
              this.expression=[{Name:this.expressionName[item],value:result.expressions[item].toFixed(2)}]
            }
          }
        }
        const { age, gender, genderProbability} = result;
        this.years=Math.round(age,0);
        this.sex=gender=='female'?'女':'男';

        new faceapi.draw.DrawTextField(
          [],
          result.detection.box.bottomLeft
        ).draw(this.canvasEl);
      });
      this.withBoxes
        ? faceapi.draw.drawDetections(this.canvasEl, resizedResults)
        : faceapi.draw.drawFaceLandmarks(this.canvasEl, resizedResults);

    },
    fnChange(e) {
      if(!e.target.files.length) return;
      this.imgEl = document.getElementById("myImg");
      this.canvasEl = document.getElementById("myCanvas");
      faceapi.bufferToImage(e.target.files[0]).then((img) => {
        this.imgEl.src= img.src;
        this.canvasEl.getContext("2d").clearRect(0, 0, this.imgEl.width, this.imgEl.height);
        this.fnRun();
      });
    },

    // 视频相关
    // 视频暂停播放
    fnPaused() {
      if (this.videoEl.paused) {
        this.videoEl.play();
        setTimeout(() => this.fnRunFaceAgeAndGender(), 300);
      } else {
        this.videoEl.pause();
      }
    },

    // 年龄性别识别绘制
    async fnRunFaceAgeAndGender() {
      if (this.videoEl.paused) return clearTimeout(this.timeout);
      // 根据模型参数识别调整结果
      this.options = new faceapi.TinyFaceDetectorOptions({
          inputSize: 512, // 160 224 320 416 512 608
          scoreThreshold: 0.5, // 0.1 ~ 0.9
        });
      // 识别绘制人脸信息
      const result = await faceapi
        .detectAllFaces(this.videoEl, this.options)
        .withFaceLandmarks()
        .withFaceExpressions()
        .withAgeAndGender();
      if (result) {
        const dims = faceapi.matchDimensions(this.myvideoCanvas, this.videoEl, true);
        const resizeResult = faceapi.resizeResults(result, dims);
        this.withBoxes?faceapi.draw.drawDetections(this.myvideoCanvas, resizeResult): faceapi.draw.drawFaceLandmarks(this.myvideoCanvas, resizeResult);
        this.videoexpression=[];
        let statunum=0;
        if (Array.isArray(resizeResult)) {
          resizeResult.forEach((result) => {
            for(let item in result.expressions){
              if(this.expressionName[item] && result.expressions[item]>statunum){
                statunum=result.expressions[item];
                this.videoexpression=[{Name:this.expressionName[item],value:result.expressions[item].toFixed(2)}];
              }
            }
            const { age, gender, genderProbability} = result;
            this.videoyears=Math.round(age,0);
            this.videosex=gender=='female'?'女':'男';
            new faceapi.draw.DrawTextField(
              [],
              result.detection.box.bottomLeft
            ).draw(this.myvideoCanvas);
          });
        } else {
          const { age, gender, genderProbability } = resizeResult;
          new faceapi.draw.DrawTextField(
            [
              `${Math.round(age, 0)} years`,
              `${gender} (${Math.round(genderProbability)})`,
            ],
            resizeResult.detection.box.bottomLeft
          ).draw(this.myvideoCanvas);
        }
      } else {
        this.myvideoCanvas
          .getContext("2d")
          .clearRect(0, 0, this.myvideoCanvas.width, this.myvideoCanvas.height);
      }
      this.timeout = setTimeout(() => this.fnRunFaceAgeAndGender());
    },

    // 更换视频,清空绘制
    videoChange(e) {
      this.videoEl = document.getElementById("myVideo");
      this.myvideoCanvas = document.getElementById("myvideoCanvas");
      if (!e.target.files.length) return;
      this.videoEl.pause();
      
      setTimeout(() => {
        this.myvideoCanvas
          .getContext("2d")
          .clearRect(0, 0, this.myvideoCanvas.width, this.myvideoCanvas.height);
        this.videoEl.src = URL.createObjectURL(e.target.files[0]);
        this.fnPaused();
      }, 300);
    },


    // 直播摄像头相关
    Openlive() {
      if (typeof window.stream === "object") return;
      clearTimeout(this.livetimeout);
      this.timeout = setTimeout(() => {
        clearTimeout(this.livetimeout);
        if(navigator.mediaDevices){
          navigator.mediaDevices
          .getUserMedia(this.constraints)
          .then(this.liveSuccess)
          .catch(this.liveError);
        }else{
          alert("请开启摄像头权限，如不是https请前往https://www.cnblogs.com/tuofei13/p/16636145.html查看教程即可开启摄像头")
        }
        
      }, 300);
    },

    // 成功启动视频媒体流
    liveSuccess(stream) {
      this.mylive = document.getElementById("mylive");
      this.myliveCanvas = document.getElementById("myliveCanvas");
      window.stream = stream; // 使流对浏览器控制台可用
      this.mylive.srcObject = stream;
      this.mylive.play();
      this.liveRun();
    },
    // 失败启动视频媒体流
    liveError(error) {
      console.log(error);
      alert("视频媒体流获取错误" + error);
    },
    // 年龄性别识别绘制
    async liveRun() {
      if (this.mylive.paused) return 
      clearTimeout(this.livetimeout);
      this.options = new faceapi.TinyFaceDetectorOptions({
          inputSize: 512, // 160 224 320 416 512 608
          scoreThreshold: 0.5, // 0.1 ~ 0.9
      });
      // 识别绘制人脸信息
      const result = await faceapi
        .detectAllFaces(this.mylive, this.options)
        .withFaceLandmarks()
        .withFaceExpressions()
        .withAgeAndGender();
      if (result && !this.mylive.paused) {
        const dims = faceapi.matchDimensions(this.myliveCanvas, this.mylive, true);
        const resizeResults = faceapi.resizeResults(result, dims);
        let statunum=0;
        this.withBoxes
          ? faceapi.draw.drawDetections(this.myliveCanvas, resizeResults)
          : faceapi.draw.drawFaceLandmarks(this.myliveCanvas, resizeResults);
        if (Array.isArray(resizeResults)) {
          resizeResults.forEach((result) => {
            for(let item in result.expressions){
              if(this.expressionName[item] && result.expressions[item]>statunum){
                statunum=result.expressions[item];
                this.cameraexpression=[{Name:this.expressionName[item],value:result.expressions[item].toFixed(2)}];
              }
            }
            const { age, gender, genderProbability } = result;
            this.camerayears=Math.round(age, 0);
            this.camerasex=gender=='female'?'女':'男'
            new faceapi.draw.DrawTextField(
              [],
              result.detection.box.bottomLeft
            ).draw(this.myliveCanvas);
          });
        } else {
          const { age, gender, genderProbability } = resizeResults;
          new faceapi.draw.DrawTextField(
            [
              `${Math.round(age, 0)} years`,
              `${gender} (${Math.round(genderProbability)})`,
            ],
            resizeResults.detection.box.bottomLeft
          ).draw(this.myliveCanvas);
        }
      } else {
        this.myliveCanvas
          .getContext("2d")
          .clearRect(0, 0, this.myliveCanvas.width, this.myliveCanvas.height);
      }
      this.livetimeout = setTimeout(() => this.liveRun());
    },
  },
};
</script>
<style scoped>
.face_expression_recognition{background: url("../../../public/img/chatgpt/face_api_bg.jpg") 100% no-repeat;background-size: 100% 100%;background-position: top;display: flex;padding: 30px;overflow: hidden;}
.Imagerecognition{background: rgba(33, 59, 112, 0.5);padding:24px;width: 305px;height: 576px;position: relative;display: inline-block;}
.Imagerecognition label{background: #001E53;color: #fff;border: 1px solid #5C77AD;padding: 8px 0;text-align: center;display: block;}
.Imagerecognition .imgbg{background:url('../../../public/img/bg04.png') 100%;background-size:305px 536px;height: 536px;}
.Imagerecognition .imgsee{width:100%;position: relative;}
.Imagerecognition .imgsee img{width: 100%; display: block;}
.Imagerecognition .imgsee canvas{position: absolute;top: 0;left: 0;width: 100%;height: 100%;}
.Imagerecognition .updataimg{position: absolute;top: 0;left: 0;width: 100%;height:100%;opacity:0;z-index:2;}
.Imagerecognition .default{text-align: center;padding-top: 120px;}
.face_expression_recognition .result{width: 293px;height: 101px;background: #001E53;margin-top:16px;padding:15px 30px;display: flex;align-items: center;}
.face_expression_recognition .result .emote{width: 102px;height: 102px;position: relative;padding-top: 45px;}
.face_expression_recognition .result .emote span{display: block;text-align: center;color: #4FE2FF;font-size: 20px;}
.face_expression_recognition .result .emote::after{content: '';position:absolute;top:0;left:0;width: 100%;height:100%;background: url('../../../public/img/bg05.png') 100% no-repeat;background-size: 100%;}
.face_expression_recognition .result .item{text-align: center;font-size: 16px;width:100px;}
.face_expression_recognition .result .item::after{content: '';background: url('../../../public/img/img01.png') no-repeat;width: 65px;height:10px;background-size: 100%;display: block;margin: 10px auto 0;}
.face_expression_recognition .result .item span{color: #4FE2FF;display: block;}
.face_expression_recognition .result .item label{font-size: 16px;color: #BDD3FF;display: block;}

.right{width:558px;display: inline-block;margin-left: 30px;}
.right .videorecognition{padding:24px;background: #001E53;height: 325px;position: relative;}
.right .videorecognition label{background: #001E53;color: #fff;border: 1px solid #5C77AD;padding: 8px 0;text-align: center;display: block;}
.right .videorecognition .videosee{width:100%;height:287px;background:url('../../../public/img/bg01.png') 100% no-repeat;background-size: 100% 100%;position: relative;}
#myVideo{width: 100%;height: 100%;}
.right .videorecognition input{position: absolute;top: 0;left: 0;width: 100%;height:100%;opacity:0;z-index:2;}
#myvideoCanvas{position: absolute;top: 0;left: 0;width: 100%;height:100%;}
.right .videorecognition .playicon{position: absolute;width: 90px;top: 50%;left: 50%;transform: translate(-50%,-50%);}
.right .camerarecognition{padding:24px;background: #001E53;height: 325px;position: relative;margin-top: 20px;}
.right .camerarecognition label{background: #001E53;color: #fff;border: 1px solid #5C77AD;padding: 8px 0;text-align: center;display: block;}
.right .camerarecognition .livesee{width:100%;height:287px;background:url('../../../public/img/bg01.png') 100% no-repeat;background-size: 100% 100%;}
.right .camerarecognition .playicon{position: absolute;width: 90px;top: 50%;left: 50%;transform: translate(-50%,-50%);}
.right .camerarecognition .livesee video{width:558px;height:287px;}

.right .Identifycontent{position: absolute;top: 100px;width: 146px;height: 116px;}
.right .Identifycontent .title{text-align: center;color: #fff;background:#5E6166;font-size: 16px;padding: 5px 0;}
.right .Identifycontent .other{background: #31343D;color: #fff;padding: 20px;}
.right .Identifycontent .other p{padding: 5px 0;}
</style>